import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  builderData: {},
  highlightComment: {
    avatar: false,
    status: '',
    ccid: 0,
    body: '',
    created: new Date(),
    openChildrenReply: false,
    openReply: false,
    subComments: {
      before: 1,
      current: 1,
      first: 1,
      items: [],
      last: 1,
      limit: 24,
      next: 1,
      totalItems: 0,
      totalPages: 1
    }
  },
  comments: {
    before: 1,
    current: 1,
    first: 1,
    items: [],
    last: 1,
    limit: 24,
    next: 1,
    totalItems: 0,
    totalPages: 1
  }
}

const mutations = {
  [types.DATA] (state, data) {
    state.builderData = data
  },
  [types.TRIGGER_REPLY_COMMENT] (state, payload) {
    if (payload.isHighlightComment) {
      if (typeof payload.parent !== 'undefined') {
        if (state.highlightComment.openChildrenReply === false) {
          state.highlightComment.openReply = true
        } else {
          state.highlightComment.openReply = false
        }
        state.highlightComment.openChildrenReply = !state.highlightComment.openChildrenReply
      } else {
        if (state.highlightComment.openChildrenReply === false) {
          state.highlightComment.openReply = !state.highlightComment.openReply
        }
        state.highlightComment.openChildrenReply = false
      }
    } else {
      if (typeof payload.parent !== 'undefined') {
        let comment = state.comments.items.find(comment => {
          return comment.ccid === payload.parent
        })
        if (typeof comment !== 'undefined') {
          if (comment.openChildrenReply === false) {
            comment.openReply = true
          } else {
            comment.openReply = false
          }
          comment.openChildrenReply = !comment.openChildrenReply
        }
      } else {
        let comment = state.comments.items.find(comment => {
          return comment.ccid === payload.id
        })
        if (typeof comment !== 'undefined') {
          if (comment.openChildrenReply === false) {
            comment.openReply = !comment.openReply
          }
          comment.openChildrenReply = false
        }
      }
    }
  },
  [types.MERGE_NEW_COMMENT] (state, data) {
    if (typeof data.parent !== 'undefined' && data.parent > 0) {
      state.comments.items = state.comments.items.map((comment) => {
        if (comment.ccid === data.parent) {
          comment.subComments.totalItems++
          comment.subComments.items.push({
            cxid: data.cxid,
            body: data.comment.body,
            ccid: data.comment.id,
            created: data.comment.created,
            nickname: data.comment.name,
            avatar: data.comment.avatar,
            status: data.comment.status,
            openChildrenReply: false,
            openReply: false,
            subject: '',
            uid: data.comment.uid,
            subComments: data.comment.subComments
          })
        }
        return comment
      })
    } else {
      state.comments.items.unshift({
        cxid: data.cxid,
        body: data.comment.body,
        ccid: data.comment.id,
        created: data.comment.created,
        nickname: data.comment.name,
        avatar: data.comment.avatar,
        status: data.comment.status,
        openChildrenReply: false,
        openReply: false,
        subject: '',
        uid: data.comment.uid,
        subComments: data.comment.subComments
      })
    }
  },
  [types.HIGHLIGHT_COMMENT] (state, data) {
    if (typeof data.appendSubComments !== 'undefined') {
      if (data.appendSubComments.items.length > 0) {
        data.appendSubComments.items.forEach((subComment) => {
          state.highlightComment.subComments.items.unshift(subComment)
        })
        state.highlightComment.subComments.before = data.appendSubComments.before
        state.highlightComment.subComments.next = data.appendSubComments.next
        state.highlightComment.subComments.current = data.appendSubComments.current
      }
    } else {
      if (data.subComments.items.length > 0) {
        data.subComments.items = data.subComments.items.reverse()
      }
      state.highlightComment = data
    }
  },
  [types.COMMENTS] (state, data) {
    if (typeof data.loadMore === 'undefined' || data.loadMore === false) {
      data.comments.items = data.comments.items.map((comment) => {
        if (comment.subComments.items.length > 0) {
          comment.subComments.items.reverse()
        }
        return comment
      })
      data.comments.items = data.comments.items.reduce((items, comment) => {
        if (state.highlightComment.ccid === 0 ||
          state.highlightComment.ccid !== comment.ccid
        ) {
          items.push(comment)
        }
        return items
      }, [])
      state.comments = data.comments
    } else {
      if (data.parent > 0) {
        state.comments.items = state.comments.items.map((comment) => {
          if (comment.ccid === data.parent) {
            data.comments.items.forEach((subComment) => {
              comment.subComments.items.unshift(subComment)
            })
            comment.subComments.before = data.comments.before
            comment.subComments.next = data.comments.next
            comment.subComments.current = data.comments.current
          }
          return comment
        })
      } else {
        data.comments.items.forEach((comment) => {
          if (comment.subComments.items.length > 0) {
            comment.subComments.items.reverse()
          }
          if (state.highlightComment.ccid === 0 ||
            state.highlightComment.ccid !== comment.ccid
          ) {
            state.comments.items.push(comment)
          }
        })
        state.comments.before = data.comments.before
        state.comments.next = data.comments.next
        state.comments.current = data.comments.current
      }
    }
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/builder/store.js